import { ActionIcon, TextInput } from "@mantine/core";
import { IconSearch, IconX } from "@tabler/icons-react";
import { useSearchParams } from "react-router-dom";

const Search = ({
  value,
  onChange,
  marginBottom = 10,
  width = 300,
  label = "",
  placeholder = "Search sessions...",
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <>
      <TextInput
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e)}
        leftSection={<IconSearch size={16} />}
        w={width}
        rightSection={
          <ActionIcon
            variant="transparent"
            color="grey"
            onClick={() =>
              setSearchParams((searchParams) => {
                searchParams.delete("search");
                return searchParams;
              })
            }
          >
            <IconX size={16} />
          </ActionIcon>
        }
        mb={marginBottom}
      />
    </>
  );
};

export default Search;
